import React from 'react';
import { ArrowRight } from 'lucide-react';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-grid">
          <div className="hero-content">
            <h1 className="hero-large">
              Pure Adaptogens.<br />
              Real Energy.<br />
              <span className="accent-orange">No Compromise.</span>
            </h1>
            <p className="body-large hero-description">
              Experience the power of lab-grown Cordyceps militaris — 100% organic, vegan, and scientifically verified for purity and potency.
            </p>
            <button onClick={scrollToContact} className="btn-primary btn-orange">
              Contact Us <ArrowRight size={16} style={{ marginLeft: '8px' }} />
            </button>
          </div>
          <div className="hero-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1506126613408-eca07ce68773" 
              alt="Wellness and yoga lifestyle"
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;